import InvoiceDisplay from '../InvoiceDisplay'
import { FulfillmentOrder, ReservationTargetType } from '../../../../../../../graphql'

export type ReservationTargetProps = {
	targetType?: ReservationTargetType | null,
	targetId?: number | null,
	fulfillmentOrder?: Pick<FulfillmentOrder, 'orderNumber'> | null,
}

export default function ReservationTarget( { targetType, targetId, fulfillmentOrder }: ReservationTargetProps ) {
	if ( targetType === ReservationTargetType.FulfillmentOrder ) {
		return fulfillmentOrder ? <span>FO-{fulfillmentOrder.orderNumber}</span> : null
	}
	if ( !targetType || !targetId ) {
		return null
	}
	switch ( targetType ) {
		case ReservationTargetType.WorkOrder:
			return <span>WO-{targetId}</span>
		case ReservationTargetType.Invoice:
			return <InvoiceDisplay targetId={targetId} />
		case ReservationTargetType.Order:
			return <span>ORD-{targetId}</span>
		default:
			return <span>{targetId}</span>
	}
}
